import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import { App, Button } from "antd";
import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { type CollectionFileFragment } from "../gql/generated/graphqlSchema.tsx";
import { ImageFile } from "./ImageFile.tsx";
import { css } from "@linaria/core";

const wrapper = css`
  position: relative;
`;

const deleteBtn = css`
  position: absolute;
  top: var(--ant-margin-xxs);
  right: var(--ant-margin-xxs);
  z-index: 1;
`;

type DeletableImageFileProps = {
  readonly file: Pick<CollectionFileFragment, "variants">;
  readonly onDelete: () => void;
  readonly children?: ReactNode;
};

export const DeletableImageFile = ({ file, onDelete, children = undefined }: DeletableImageFileProps) => {
  const { t } = useTranslation();
  const { modal } = App.useApp();

  const handleDelete = () => {
    modal.confirm({
      title: t("phone.deleteTitle"),
      content: t("phone.deleteConfirm"),
      okButtonProps: { danger: true, icon: <DeleteOutlined /> },
      cancelButtonProps: { icon: <CloseOutlined /> },
      okText: t("phone.delete"),
      onOk: onDelete,
    });
  };

  return (
    <div className={wrapper}>
      <ImageFile file={file} />
      <Button
        className={deleteBtn}
        color="danger"
        icon={<DeleteOutlined />}
        onClick={(e) => {
          e.stopPropagation();
          handleDelete();
        }}
        size="small"
        variant="outlined"
      />
      {children}
    </div>
  );
};
